import helper from "../helper";
// import user from "../store/modules/user";

let getPassOrderUrl = helper.getPassOrderUrlWithParameters
let getPassOrderAllowed = helper.allowedPassOrderUrl

export default {
    getPassOrderUrl,
    getByRecievedUrlData: (url, gets = null) => getPassOrderUrl(
        url.basename,
        url.action,
        url.params,
        gets
    ),
    ADMIN: {
        ALLOWED: () => getPassOrderAllowed(
          "admin|references|visitors-list",
          "list"
        ),
        VISITORS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "admin|references|visitors-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "admin|references|visitors-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "admin|references|visitors-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|references|visitors-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            CHECK:
                (id, gets = null) => getPassOrderUrl(
                    "admin|references|visitors-check",
                    "check",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|references|visitors-detail",
                    "destroy",
                    {id: id},
                    gets
                )
        },
        ROLES: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "admin|roles|roles-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "admin|roles|roles-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "admin|roles|roles-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|roles|roles-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|roles|roles-detail",
                    "destroy",
                    {id: id},
                    gets
                ),
            LOG_ROLES:
                (id, gets = null) => getPassOrderUrl(
                "admin|roles|roles-log",
                "log",
                {id: id},
                gets
                )
        },
        ORDERS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "admin|orders|orders-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "admin|orders|orders-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "admin|orders|orders-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|orders|orders-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|orders|orders-detail",
                    "destroy",
                    {id: id},
                    gets
                ),
            LOG_GUARD_POST:
                (id, gets = null) => getPassOrderUrl(
                    "admin|orders|orders-log",
                    "log",
                    {id: id},
                    gets
                ),
            LOG_STATUS:
                (id, gets = null) => getPassOrderUrl(
                "admin|orders|orders-statuses",
                "statuses",
                {id: id},
                gets
                ),
            ADDITIONAL:{
                LIST:
                    (order_number, gets = null) => getPassOrderUrl(
                        "admin|orders|additional-list",
                        "list",
                        {order_number: order_number},
                        gets
                    ),
                DETAIL:
                    (order_number, id, gets = null) => getPassOrderUrl(
                        "admin|orders|additional-detail",
                        "retrieve",
                        {order_number: order_number, id: id},
                        gets
                    ),
                CREATE:
                    (order_number, gets = null) => getPassOrderUrl(
                        "admin|orders|additional-list",
                        "create",
                        {order_number: order_number},
                        gets
                    ),
                UPDATE:
                    (order_number, id, gets = null) => getPassOrderUrl(
                        "admin|orders|additional-detail",
                        "partial_update",
                        {order_number: order_number, id: id},
                        gets
                    ),
                DELETE:
                    (order_number, id, gets = null) => getPassOrderUrl(
                        "admin|orders|additional-detail",
                        "destroy",
                        {order_number: order_number, id: id},
                        gets
                    )
            },
            VISITORS: {
                LIST:
                    (order_number, gets = null) => getPassOrderUrl(
                        "admin|orders|visitors-list",
                        "list",
                        {order_number: order_number},
                        gets
                    ),
                DETAIL:
                    (order_number, id, gets = null) => getPassOrderUrl(
                        "admin|orders|visitors-detail",
                        "retrieve",
                        {order_number: order_number, id: id},
                        gets
                    ),
                CREATE:
                    (order_number, gets = null) => getPassOrderUrl(
                        "admin|orders|visitors-list",
                        "create",
                        {order_number: order_number},
                        gets
                    ),
                UPDATE:
                    (order_number, id, gets = null) => getPassOrderUrl(
                        "admin|orders|visitors-detail",
                        "partial_update",
                        {order_number: order_number, id: id},
                        gets
                    ),
                DELETE:
                    (order_number, id, gets = null) => getPassOrderUrl(
                        "admin|orders|visitors-detail",
                        "destroy",
                        {order_number: order_number, id: id},
                        gets
                    )
            }
        },
        FIELDS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "admin|orders|fields-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "admin|orders|fields-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "admin|orders|fields-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|orders|fields-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|orders|fields-detail",
                    "destroy",
                    {id: id},
                    gets
                )
        },
        FILE: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "admin|orders|unload|request-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "admin|orders|unload|request-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            UNLOADING:
                (gets = null) => getPassOrderUrl(
                    "admin|orders|orders-need-unloading",
                    "need_unloading",
                    {},
                    gets
                )
        },
        CARS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "admin|references|cars-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "admin|references|cars-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "admin|references|cars-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|references|cars-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|references|cars-detail",
                    "destroy",
                    {id: id},
                    gets
                )
        },
        UID_USER:{
            CARS: {
                LIST:
                    (user_uid, gets = null) => getPassOrderUrl(
                        "admin|references|user|cars-list",
                        "list",
                        {user_uid: user_uid},
                        gets
                    ),
                DETAIL:
                    (user_uid, id, gets = null) => getPassOrderUrl(
                        "admin|references|user|cars-detail",
                        "retrieve",
                        {user_uid: user_uid, id: id},
                        gets
                    ),
                CREATE:
                    (user_uid, gets = null) => getPassOrderUrl(
                        "admin|references|user|cars-list",
                        "create",
                        {user_uid: user_uid},
                        gets
                    ),
                UPDATE:
                    (user_uid, id, gets = null) => getPassOrderUrl(
                        "admin|references|user|cars-detail",
                        "partial_update",
                        {user_uid: user_uid, id: id},
                        gets
                    ),
                DELETE:
                    (user_uid, id, gets = null) => getPassOrderUrl(
                        "admin|references|user|cars-detail",
                        "destroy",
                        {user_uid: user_uid, id: id},
                        gets
                    )
            },
            VISITORS: {
                LIST:
                    (user_uid, gets = null) => getPassOrderUrl(
                        "admin|references|user|visitors-list",
                        "list",
                        {user_uid: user_uid},
                        gets
                    ),
                DETAIL:
                    (user_uid, id, gets = null) => getPassOrderUrl(
                        "admin|references|user|visitors-detail",
                        "retrieve",
                        {user_uid: user_uid, id: id},
                        gets
                    ),
                CREATE:
                    (user_uid, gets = null) => getPassOrderUrl(
                        "admin|references|user|visitors-list",
                        "create",
                        {user_uid: user_uid},
                        gets
                    ),
                UPDATE:
                    (user_uid, id, gets = null) => getPassOrderUrl(
                        "admin|references|user|visitors-detail",
                        "partial_update",
                        {user_uid: user_uid, id: id},
                        gets
                    ),
                DELETE:
                    (user_uid, id, gets = null) => getPassOrderUrl(
                        "admin|references|user|visitors-detail",
                        "destroy",
                        {user_uid: user_uid, id: id},
                        gets
                    )
            }
        },
        CHATS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "admin|chats|chats-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "admin|chats|chats-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "admin|chats|chats-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|chats|chats-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|chats|chats-detail",
                    "destroy",
                    {id: id},
                    gets
                )
        },
        ORGANIZATIONS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "admin|references|organization-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "admin|references|organization-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "admin|references|organization-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|references|organization-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|references|organization-detail",
                    "destroy",
                    {id: id},
                    gets
                )
        },
        REPLACEMENTS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "admin|roles|replacement-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "admin|roles|replacement-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "admin|roles|replacement-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|roles|replacement-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|roles|replacement-detail",
                    "destroy",
                    {id: id},
                    gets
                )
        },
        BANS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "admin|roles|bans-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "admin|roles|bans-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "admin|roles|bans-list",
                    "create",
                    null,
                    gets
                ),
            UNBAN:
                (id, gets = null) => getPassOrderUrl(
                    "admin|roles|bans-unban",
                    "unban",
                    {id: id},
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|roles|bans-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "admin|roles|bans-detail",
                    "destroy",
                    {id: id},
                    gets
                )
        },
        GUARD: {
            POST: {
                LIST:
                    (gets = null) => getPassOrderUrl(
                        "admin|references|guard|post-list",
                        "list",
                        null,
                        gets
                    ),
                DETAIL:
                    (id, gets = null) => getPassOrderUrl(
                        "admin|references|guard|post-detail",
                        "retrieve",
                        {id: id},
                        gets
                    ),
                CREATE:
                    (gets = null) => getPassOrderUrl(
                        "admin|references|guard|post-list",
                        "create",
                        null,
                        gets
                    ),
                UPDATE:
                    (id, gets = null) => getPassOrderUrl(
                        "admin|references|guard|post-detail",
                        "update",
                        {id: id},
                        gets
                    ),
                DELETE:
                    (id, gets = null) => getPassOrderUrl(
                        "admin|references|guard|post-detail",
                        "destroy",
                        {id: id},
                        gets
                    )
            },
            BUILDING: {
                LIST:
                    (post_id, gets = null) => getPassOrderUrl(
                        "admin|references|guard|post|building-list",
                        "list",
                        {post_id: post_id},
                        gets
                    ),
                DETAIL:
                    (id, post_id, gets = null) => getPassOrderUrl(
                        "admin|references|guard|post|building-detail",
                        "retrieve",
                        {post_id: post_id, id: id},
                        gets
                    ),
                CREATE:
                    (post_id, gets = null) => getPassOrderUrl(
                        "admin|references|guard|post|building-list",
                        "create",
                        {post_id: post_id},
                        gets
                    ),
                UPDATE:
                    (id, post_id, gets = null) => getPassOrderUrl(
                        "admin|references|guard|post|building-detail",
                        "partial_update",
                        {post_id: post_id, id: id},
                        gets
                    ),
                DELETE:
                    (id, post_id, gets = null) => getPassOrderUrl(
                        "admin|references|guard|post|building-detail",
                        "destroy",
                        {post_id: post_id, id: id},
                        gets
                    )
            }
        }

    }
}
